import React from "react";
import { Modal } from "react-bootstrap";
import FormikForm from "components/shared/FormikForm";

export default function WalletBalancePop({
  show,
  handleClose,
  title,
  loading,
  initialValues,
  inputFields,
  handleConfirm,
  Validation,
  onValuesChange, // ADD THIS
}) {
  // Extract helperText from amount field to display separately
  const amountField = inputFields.find((f) => f.name === "amount");

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* ADD THIS — shows "Available: X" below the modal header */}
        {amountField?.helperText && (
          <h6 className="text-muted d-block mb-2 pl-3">
            {amountField.helperText}
          </h6>
        )}
        <FormikForm
          initialValues={initialValues}
          validationSchema={Validation}
          onSubmit={handleConfirm}
          loading={loading}
          inputFields={inputFields}
          buttonText={"Submit"}
          col={6}
          onValuesChange={onValuesChange} // ADD THIS
        />
      </Modal.Body>
    </Modal>
  );
}